module.exports = __webpack_public_path__ + "media/personas/bg-countries-d7cc846f.jpg";